import { ReactNode } from 'react'
import * as S from './ServiceGrid.styles'

export type ServiceGridProps = {
  children: ReactNode
  columns?: number
}

export default function ServiceGrid({ children, columns = 4 }: ServiceGridProps) {
  return (
    <S.Container>
      <S.Grid $columns={columns}>
        {children}
      </S.Grid>
    </S.Container>
  )
}
